// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3dTIw","content":"GlobalSearch_content__A5w7n"};